import { useAppSelector } from '../../store/hooks';

const useApp = () => useAppSelector((state) => state.app);

export default useApp;
